import { render, staticRenderFns } from "./ProfileUpdateModal.vue?vue&type=template&id=2dc7e78e&scoped=true"
import script from "./ProfileUpdateModal.vue?vue&type=script&lang=ts"
export * from "./ProfileUpdateModal.vue?vue&type=script&lang=ts"
import style0 from "./ProfileUpdateModal.vue?vue&type=style&index=0&id=2dc7e78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7e78e",
  null
  
)

export default component.exports